import React from "react";

import BlueprintContext, { BlueprintContextState } from "./BlueprintContext";

// Wraps around BlueprintEditor to be able to pull global state anywhere in tree via useContext
const useBlueprintContext = (): BlueprintContextState => React.useContext(BlueprintContext);

export default useBlueprintContext;
